import { useState } from "react";
import EmojiPicker, { Categories } from "emoji-picker-react";

// Catholic custom emojis - images
const CATHOLIC_IMAGE_EMOJIS = [
  { id: "rosary", name: "Rosary", url: "https://static.prod-images.emergentagent.com/jobs/6db3c86d-ba5f-4f6d-b10b-a1285ec9382a/images/3014c3000b46c672a9944d45407d941b551aa33ab20186b95fd491c497c1a362.png" },
  { id: "crucifix", name: "Crucifix", url: "https://static.prod-images.emergentagent.com/jobs/6db3c86d-ba5f-4f6d-b10b-a1285ec9382a/images/15715a445455d8467205e715e7d63f53301d572cc75ac2b1fdd8e1cafcac6bd7.png" },
  { id: "sacred_heart", name: "Sacred Heart", url: "https://static.prod-images.emergentagent.com/jobs/6db3c86d-ba5f-4f6d-b10b-a1285ec9382a/images/095dba082813ad447b1c874fc9da00fb8142af9f8d4b2653c727fa09e6999e55.png" },
  { id: "chalice", name: "Chalice", url: "https://static.prod-images.emergentagent.com/jobs/6db3c86d-ba5f-4f6d-b10b-a1285ec9382a/images/3b0087bcdab7c2c63a21e98ad11f423f6e279feefb72196639cf1b49539588f0.png" },
  { id: "monstrance", name: "Monstrance", url: "https://static.prod-images.emergentagent.com/jobs/6db3c86d-ba5f-4f6d-b10b-a1285ec9382a/images/eec3217b76f97e11ad1b516124e4d6499b37a5b88e8bbf875976f7d6546f39c2.png" },
  { id: "mary", name: "Virgin Mary", url: "https://static.prod-images.emergentagent.com/jobs/6db3c86d-ba5f-4f6d-b10b-a1285ec9382a/images/33145cf740c6b162c4f0262412384cf8f4d68b7b2f7c385bca2adee15c87aef0.png" },
  { id: "dove", name: "Holy Spirit Dove", url: "https://static.prod-images.emergentagent.com/jobs/6db3c86d-ba5f-4f6d-b10b-a1285ec9382a/images/16365a3ea9072c45c9263c5b42093494e0a965696c3f7940c988041be0371136.png" },
  { id: "praying_rosary", name: "Praying with Rosary", url: "https://static.prod-images.emergentagent.com/jobs/6db3c86d-ba5f-4f6d-b10b-a1285ec9382a/images/17feef59476397334e6870f3b786f781e39a0e12f060766bdc3ecd87460906f6.png" },
];

// Catholic Unicode symbols
const CATHOLIC_SYMBOL_EMOJIS = [
  { symbol: "✝", name: "Latin Cross" },
  { symbol: "✞", name: "Cross Outline" },
  { symbol: "✟", name: "Cross Patonce" },
  { symbol: "♱", name: "Cross of Lorraine" },
  { symbol: "☧", name: "Chi Rho" },
  { symbol: "✠", name: "Maltese Cross" },
  { symbol: "⳩", name: "Coptic Cross" },
  { symbol: "⛪", name: "Church" },
  { symbol: "🕊", name: "Dove" },
  { symbol: "🐑", name: "Lamb" },
  { symbol: "⚜", name: "Fleur-de-lis" },
  { symbol: "🜋", name: "Alchemical Cross" },
  { symbol: "♝", name: "Bishop" },
  { symbol: "𓃔", name: "Egyptian Lamb" },
];

// Combined for export
const CATHOLIC_EMOJIS = CATHOLIC_IMAGE_EMOJIS;

// Allowed categories - excluding flags (has pride flags), symbols (has religious symbols of other faiths)
const ALLOWED_CATEGORIES = [
  { category: Categories.SUGGESTED, name: "Recently Used" },
  { category: Categories.CUSTOM, name: "Catholic" },
  { category: Categories.SMILEYS_PEOPLE, name: "Smileys" },
  { category: Categories.ANIMALS_NATURE, name: "Nature" },
  { category: Categories.FOOD_DRINK, name: "Food" },
  { category: Categories.TRAVEL_PLACES, name: "Places" },
  { category: Categories.ACTIVITIES, name: "Activities" },
  { category: Categories.OBJECTS, name: "Objects" },
];

// Emojis to explicitly hide (by unified code) - curated for Catholic community
const HIDDEN_EMOJIS = [
  // === DEVILS, DEMONS, OCCULT ===
  "1f608", // smiling face with horns
  "1f47f", // angry face with horns
  "1f479", // ogre
  "1f47a", // goblin
  "1f47d", // alien
  "1f47e", // alien monster
  "1f9db", // vampire
  "1f9df", // zombie
  "1f9d9", // mage/wizard
  "1f9da", // fairy
  "1f9dc", // merperson
  "1f9dd", // elf
  "1f9de", // genie
  "1f52e", // crystal ball
  "1f9ff", // nazar amulet
  "1faac", // hamsa
  
  // === PRIDE/LGBTQ FLAGS AND COUPLES ===
  "1f3f3-fe0f-200d-1f308", // rainbow flag
  "1f3f3-fe0f-200d-26a7-fe0f", // transgender flag
  "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468", // kiss: man, man
  "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469", // kiss: woman, woman
  "1f468-200d-2764-fe0f-200d-1f468", // couple with heart: man, man
  "1f469-200d-2764-fe0f-200d-1f469", // couple with heart: woman, woman
  "1f468-200d-1f468-200d-1f466", // family: man, man, boy
  "1f468-200d-1f468-200d-1f467", // family: man, man, girl
  "1f468-200d-1f468-200d-1f467-200d-1f466", // family: man, man, girl, boy
  "1f468-200d-1f468-200d-1f466-200d-1f466", // family: man, man, boy, boy
  "1f468-200d-1f468-200d-1f467-200d-1f467", // family: man, man, girl, girl
  "1f469-200d-1f469-200d-1f466", // family: woman, woman, boy
  "1f469-200d-1f469-200d-1f467", // family: woman, woman, girl
  "1f469-200d-1f469-200d-1f467-200d-1f466", // family: woman, woman, girl, boy
  "1f469-200d-1f469-200d-1f466-200d-1f466", // family: woman, woman, boy, boy
  "1f469-200d-1f469-200d-1f467-200d-1f467", // family: woman, woman, girl, girl
  
  // === NON-CHRISTIAN RELIGIOUS SYMBOLS ===
  "262a-fe0f", // star and crescent (Islam)
  "1f549-fe0f", // om (Hinduism)
  "2638-fe0f", // wheel of dharma (Buddhism)
  "2721-fe0f", // star of david (Judaism)
  "1f52f", // six pointed star
  "1f54e", // menorah
  "262f-fe0f", // yin yang (Taoism)
  "1f54c", // mosque
  "1f6d5", // hindu temple
  "1f54d", // synagogue
  "26e9-fe0f", // shinto shrine
  "1f54b", // kaaba
  "1fa94", // diya lamp
  
  // === ZODIAC SIGNS ===
  "26ce", // ophiuchus
  "2648", // aries
  "2649", // taurus
  "264a", // gemini
  "264b", // cancer
  "264c", // leo
  "264d", // virgo
  "264e", // libra
  "264f", // scorpius
  "2650", // sagittarius
  "2651", // capricorn
  "2652", // aquarius
  "2653", // pisces
  
  // === OFFENSIVE GESTURES ===
  "1f595", // middle finger
  "1f918", // sign of the horns
  "1f92c", // face with symbols on mouth (swearing)
  
  // === MONEY-FOCUSED ===
  "1f911", // money-mouth face
  
  // === ROBOT ===
  "1f916", // robot
  
  // === CAT FACES (per user preference) ===
  "1f63a", // grinning cat
  "1f638", // grinning cat with smiling eyes
  "1f639", // cat with tears of joy
  "1f63b", // smiling cat with heart-eyes
  "1f63c", // cat with wry smile
  "1f63d", // kissing cat
  "1f640", // weary cat
  "1f63f", // crying cat
  "1f63e", // pouting cat
  
  // === BODY PARTS (per user preference) ===
  "1f932", // palms up together
  "270d-fe0f", // writing hand
  "1f485", // nail polish
  "1f933", // selfie
  "1f9be", // mechanical arm
  "1f9bf", // mechanical leg
  "1f9b5", // leg
  "1f9b6", // foot
  "1f442", // ear
  "1f9bb", // ear with hearing aid
  "1f443", // nose
  "1f9e0", // brain
  "1fac0", // anatomical heart
  "1fac1", // lungs
  "1f9b7", // tooth
  "1f9b4", // bone
  "1f440", // eyes
  "1f441-fe0f", // eye
  "1f445", // tongue
  "1f444", // mouth
  
  // === PEOPLE EMOJIS (per user preference) ===
  "1f476", // baby
  "1f9d2", // child
  "1f466", // boy
  "1f467", // girl
  "1f9d1", // person
  "1f471", // person blond hair
  "1f468", // man
  "1f9d4", // person beard
  "1f469", // woman
  "1f9d3", // older person
  "1f474", // old man
  "1f475", // old woman
  "1f64d", // person frowning
  "1f64e", // person pouting
  "1f645", // person gesturing no
  "1f646", // person gesturing ok
  "1f481", // person tipping hand
  "1f64b", // person raising hand
  "1f9cf", // deaf person
  "1f647", // person bowing
  "1f926", // person facepalming
  "1f937", // person shrugging
  "1f46e", // police officer
  "1f575-fe0f", // detective
  "1f482", // guard
  "1f977", // ninja
  "1f477", // construction worker
  "1f934", // prince
  "1f478", // princess
  "1f473", // person wearing turban
  "1f472", // person with skullcap
  "1f9d5", // woman with headscarf
  "1f935", // person in tuxedo
  "1f470", // person with veil
  "1f930", // pregnant woman
  "1f931", // breast-feeding
  "1f47c", // baby angel
  "1f385", // santa claus
  "1f936", // mrs. claus
  "1f9b8", // superhero
  "1f9b9", // supervillain
  "1f486", // person getting massage
  "1f487", // person getting haircut
  "1f6b6", // person walking
  "1f9cd", // person standing
  "1f9ce", // person kneeling
  "1f3c3", // person running
  "1f483", // woman dancing
  "1f57a", // man dancing
  "1f574-fe0f", // person in suit levitating
  "1f46f", // people with bunny ears
  "1f9d6", // person in steamy room
  "1f9d7", // person climbing
  "1f93a", // person fencing
  "1f3c7", // horse racing
  "26f7-fe0f", // skier
  "1f3c2", // snowboarder
  "1f3cc-fe0f", // person golfing
  "1f3c4", // person surfing
  "1f6a3", // person rowing boat
  "1f3ca", // person swimming
  "26f9-fe0f", // person bouncing ball
  "1f3cb-fe0f", // person lifting weights
  "1f6b4", // person biking
  "1f6b5", // person mountain biking
  "1f938", // person cartwheeling
  "1f93c", // people wrestling
  "1f93d", // person playing water polo
  "1f93e", // person playing handball
  "1f939", // person juggling
  "1f9d8", // person in lotus position
  "1f6c0", // person taking bath
  "1f6cc", // person in bed
  
  // === COUPLES AND FAMILIES (per user preference) ===
  "1f46d", // women holding hands
  "1f46b", // woman and man holding hands
  "1f46c", // men holding hands
  "1f48f", // kiss
  "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468", // kiss woman man
  "1f491", // couple with heart
  "1f469-200d-2764-fe0f-200d-1f468", // couple with heart woman man
  "1f46a", // family
  "1f468-200d-1f469-200d-1f466", // family man woman boy
  "1f468-200d-1f469-200d-1f467", // family man woman girl
  "1f468-200d-1f469-200d-1f467-200d-1f466", // family man woman girl boy
  "1f468-200d-1f469-200d-1f466-200d-1f466", // family man woman boy boy
  "1f468-200d-1f469-200d-1f467-200d-1f467", // family man woman girl girl
  "1f468-200d-1f466", // family man boy
  "1f468-200d-1f466-200d-1f466", // family man boy boy
  "1f468-200d-1f467", // family man girl
  "1f468-200d-1f467-200d-1f466", // family man girl boy
  "1f468-200d-1f467-200d-1f467", // family man girl girl
  "1f469-200d-1f466", // family woman boy
  "1f469-200d-1f466-200d-1f466", // family woman boy boy
  "1f469-200d-1f467", // family woman girl
  "1f469-200d-1f467-200d-1f466", // family woman girl boy
  "1f469-200d-1f467-200d-1f467", // family woman girl girl
  
  // === COLORED HEARTS (keeping red only) ===
  "1f9e1", // orange heart
  "1f49b", // yellow heart
  "1f49a", // green heart
  "1f499", // blue heart
  "1f49c", // purple heart
  "1f5a4", // black heart
  "1f90d", // white heart
  "1f90e", // brown heart
  "2763-fe0f", // heart exclamation
  "1f495", // two hearts
  "1f49e", // revolving hearts
  "1f493", // beating heart
  "1f497", // growing heart
  "1f496", // sparkling heart
  "1f49d", // heart with ribbon
  
  // === FLAGS (keeping only Vatican) ===
  "1f3c1", // checkered flag
  "1f6a9", // triangular flag
  
  // === FOOD (all per user preference) ===
  "1f347", "1f348", "1f349", "1f34a", "1f34b", "1f34c", "1f34d", "1f96d",
  "1f34e", "1f34f", "1f350", "1f351", "1f352", "1f353", "1fad0", "1f95d",
  "1f345", "1fad2", "1f965", "1f951", "1f346", "1f954", "1f955", "1f33d",
  "1f336-fe0f", "1fad1", "1f952", "1f96c", "1f966", "1f9c4", "1f9c5",
  "1f344", "1f95c", "1f330", "1f35e", "1f950", "1f956", "1fad3", "1f968",
  "1f96f", "1f95e", "1f9c7", "1f9c0", "1f356", "1f357", "1f969", "1f953",
  "1f354", "1f35f", "1f355", "1f32d", "1f96a", "1f32e", "1f32f", "1fad4",
  "1f959", "1f9c6", "1f95a", "1f373", "1f958", "1f372", "1fad5", "1f963",
  "1f957", "1f37f", "1f9c8", "1f9c2", "1f96b", "1f371", "1f358", "1f359",
  "1f35a", "1f35b", "1f35c", "1f35d", "1f360", "1f362", "1f363", "1f364",
  "1f365", "1f96e", "1f361", "1f95f", "1f960", "1f961", "1f980", "1f99e",
  "1f990", "1f991", "1f9aa", "1f366", "1f367", "1f368", "1f369", "1f36a",
  "1f382", "1f370", "1f9c1", "1f967", "1f36b", "1f36c", "1f36d", "1f36e",
  "1f36f", "1f37c", "1f95b", "2615", "1fad6", "1f375", "1f376", "1f37e",
  "1f377", "1f378", "1f379", "1f37a", "1f37b", "1f942", "1f943", "1f964",
  "1f9cb", "1f9c3", "1f9c9", "1f9ca", "1f962", "1f37d-fe0f", "1f374",
  "1f944", "1f52a", "1f3fa",
  
  // === ANIMALS (all per user preference) ===
  "1f436", "1f431", "1f42d", "1f439", "1f430", "1f98a", "1f43b", "1f43c",
  "1f428", "1f42f", "1f42e", "1f437", "1f438", "1f435", "1f648", "1f649",
  "1f64a", "1f412", "1f414", "1f427", "1f426", "1f424", "1f423", "1f425",
  "1f986", "1f985", "1f989", "1f987", "1f43a", "1f417", "1f434", "1f984",
  "1f41d", "1fab1", "1f41b", "1f98b", "1f40c", "1f41e", "1f41c", "1fab0",
  "1fab2", "1fab3", "1f99f", "1f997", "1f577-fe0f", "1f578-fe0f", "1f982",
  "1f422", "1f98e", "1f996", "1f995", "1f419", "1f421", "1f420", "1f42c",
  "1f433", "1f40b", "1f988", "1f40a", "1f405", "1f406", "1f993", "1f98d",
  "1f9a7", "1f9a3", "1f418", "1f99b", "1f98f", "1f42a", "1f42b", "1f992",
  "1f998", "1f9ac", "1f403", "1f402", "1f404", "1f40e", "1f416", "1f40f",
  "1f999", "1f410", "1f98c", "1f415", "1f429", "1f9ae", "1f415-200d-1f9ba",
  "1f408", "1f408-200d-2b1b", "1fab6", "1f413", "1f983", "1f9a4", "1f99a",
  "1f99c", "1f9a2", "1f9a9", "1f54a-fe0f", "1f407", "1f99d", "1f9a8",
  "1f9a1", "1f9ab", "1f9a6", "1f9a5", "1f401", "1f400", "1f43f-fe0f",
  "1f994", "1f43e", "1f409", "1f432",
  
  // === PLANTS (per user preference) ===
  "1f335", "1fab5", "1f331", "1f33f", "1f38d", "1fab4", "1f38b", "1f343",
  "1f342", "1f341", "1fab9", "1f33e", "1f33a", "1f33b", "1f339", "1f940",
  "1f337", "1f33c", "1f338", "1f490", "1f41a", "1fab8", "1faa8",
  
  // === WEATHER/SPACE (per user preference) ===
  "1f311", "1f312", "1f313", "1f314", "1f315", "1f316", "1f317", "1f318",
  "1f319", "1f31a", "1f31b", "1f31c", "1f321-fe0f", "2600-fe0f", "1f31d",
  "1f31e", "1fa90", "1f320", "1f30c", "2601-fe0f", "26c5", "26c8-fe0f",
  "1f324-fe0f", "1f325-fe0f", "1f326-fe0f", "1f327-fe0f", "1f328-fe0f",
  "1f329-fe0f", "1f32a-fe0f", "1f32b-fe0f", "1f32c-fe0f", "1f300",
  "1f302", "2602-fe0f", "2614", "26f1-fe0f", "26a1", "2744-fe0f",
  "2603-fe0f", "26c4", "2604-fe0f", "1f525", "1f4a7", "1f30a",
  
  // === BUILDINGS (per user preference) ===
  "1f3db-fe0f", "1f3f0", "1f3ef", "1f3df-fe0f", "1f3e0", "1f3e1", "1f3e2",
  "1f3e3", "1f3e4", "1f3e5", "1f3e6", "1f3e8", "1f3e9", "1f3ea", "1f3eb",
  "1f3ec", "1f3ed", "1f3d7-fe0f", "1f9f1", "1f6d6", "1f3d8-fe0f",
  "1f3da-fe0f", "1f5fc", "1f5fd", "1f5ff",
  
  // === OBJECTS (per user preference) ===
  "1f48d", "1f48e", "1f4ff", "1f488", "1f52d", "1f52c", "1f573-fe0f",
  "1f48a", "1f489", "1fa78", "1fa79", "1fa7a", "1f6aa", "1f6cf-fe0f",
  "1f6cb-fe0f", "1fa91", "1f6bd", "1f6bf", "1f6c1", "1faa4", "1fa92",
  "1f9f4", "1f9f7", "1f9f9", "1f9fa", "1f9fb", "1faa3", "1f9fc", "1faa5",
  "1f9fd", "1f9ef", "1f6d2", "1f6ac", "26b0-fe0f", "1faa6", "26b1-fe0f",
  "1f3b0", "1f3b1", "1f52b", "1f4a3", "1fa93", "1f3f9",
  "1f527", "1fa9b", "1f529", "2699-fe0f", "1f5dc-fe0f", "2696-fe0f",
  "1f9af", "1f517", "26d3-fe0f", "1fa9d", "1f9f0", "1f9f2", "1fa9c",
  "2697-fe0f", "1f9ea", "1f9eb", "1f9ec",
  
  // === ELECTRONICS (per user preference) ===
  "1f4f1", "1f4f2", "260e-fe0f", "1f4de", "1f4df", "1f4e0", "1f50b",
  "1f50c", "1f4bb", "1f5a5-fe0f", "1f5a8-fe0f", "2328-fe0f", "1f5b1-fe0f",
  "1f5b2-fe0f", "1f4bd", "1f4be", "1f4bf", "1f4c0", "1f9ee", "1f3a5",
  "1f39e-fe0f", "1f4fd-fe0f", "1f3ac", "1f4fa", "1f4f7", "1f4f8", "1f4f9",
  "1f4fc", "1f50d", "1f50e", "1f56f-fe0f", "1f4a1", "1f526", "1f3ee",
  
  // === BOOKS/OFFICE (per user preference) ===
  "1f4d4", "1f4d5", "1f4d6", "1f4d7", "1f4d8", "1f4d9", "1f4da", "1f4d3",
  "1f4d2", "1f4c3", "1f4dc", "1f4c4", "1f4f0", "1f5de-fe0f", "1f4d1",
  "1f516", "1f3f7-fe0f", "1f4b0", "1fa99", "1f4b4", "1f4b5", "1f4b6",
  "1f4b7", "1f4b8", "1f4b3", "1f9fe", "1f4b9", "2709-fe0f", "1f4e7",
  "1f4e8", "1f4e9", "1f4e4", "1f4e5", "1f4e6", "1f4eb", "1f4ea", "1f4ec",
  "1f4ed", "1f4ee", "1f5f3-fe0f", "270f-fe0f", "2712-fe0f", "1f58b-fe0f",
  "1f58a-fe0f", "1f58c-fe0f", "1f58d-fe0f", "1f4dd", "1f4bc", "1f4c1",
  "1f4c2", "1f5c2-fe0f", "1f4c5", "1f4c6", "1f5d2-fe0f", "1f5d3-fe0f",
  "1f4c7", "1f4c8", "1f4c9", "1f4ca", "1f4cb", "1f4cc", "1f4cd", "1f4ce",
  "1f587-fe0f", "1f4cf", "1f4d0", "2702-fe0f", "1f5c3-fe0f", "1f5c4-fe0f",
  "1f5d1-fe0f", "1f512", "1f513", "1f50f", "1f510", "1f511", "1f5dd-fe0f",
  "1f528", "26cf-fe0f", "2692-fe0f", "1f6e0-fe0f", "1f5e1-fe0f",
  "2694-fe0f", "1fa83", "1f6e1-fe0f", "1fa9a",
  
  // === SPORTS (per user preference) ===
  "26bd", "1f3c0", "1f3c8", "26be", "1f94e", "1f3be", "1f3d0", "1f3c9",
  "1f94f", "1f3b3", "1f3cf", "1f3d1", "1f3d2", "1f94d", "1f3d3", "1f3f8",
  "1f94a", "1f94b", "1f945", "26f3", "26f8-fe0f", "1f3a3", "1f93f",
  "1f3bd", "1f3bf", "1f6f7", "1f94c", "1f3af", "1fa80", "1fa81",
  "1f3ae", "1f3b2", "1f9e9", "1f9f8", "1fa86",
  
  // === CARDS ===
  "2660-fe0f", "2665-fe0f", "2666-fe0f", "2663-fe0f", "265f-fe0f",
  "1f0cf", "1f004", "1f3b4",
  
  // === ARTS/MUSIC (per user preference) ===
  "1f3ad", "1f5bc-fe0f", "1f3a8", "1f9f5", "1faa1", "1f9f6", "1faa2",
  "1f3bc", "1f3b5", "1f3b6", "1f399-fe0f", "1f39a-fe0f", "1f39b-fe0f",
  "1f3a4", "1f3a7", "1f4fb", "1f3b7", "1fa97", "1f3b8", "1f3b9", "1f3ba",
  "1f3bb", "1fa95", "1f941", "1fa98",
  
  // === CELEBRATIONS (per user preference) ===
  "1f380", "1f381", "1f397-fe0f", "1f39f-fe0f", "1f3ab", "1f396-fe0f",
  "1f3c6", "1f3c5", "1f947", "1f948", "1f949", "1f3aa", "1fa70",
  "1f383", "1f384", "1f386", "1f387", "1f9e8", "2728", "1f388", "1f389",
  "1f38a", "1f38e", "1f38f", "1f390", "1f391", "1f9e7",
];

export default function CatholicEmojiPicker({ onEmojiClick, width = 300, height = 400 }) {
  const [activeTab, setActiveTab] = useState("catholic");
  
  const handleStandardEmojiClick = (emojiObject) => {
    onEmojiClick({ emoji: emojiObject.emoji, type: "standard" });
  };
  
  const handleCatholicEmojiClick = (emoji) => {
    onEmojiClick({ emoji: `[catholic:${emoji.id}]`, type: "catholic", url: emoji.url, name: emoji.name });
  };
  
  const handleSymbolEmojiClick = (emoji) => {
    onEmojiClick({ emoji: emoji.symbol, type: "symbol" });
  };
  
  return (
    <div className="bg-white rounded-lg shadow-xl border border-[#E5E0D5] overflow-hidden" style={{ width: Math.min(width, typeof window !== 'undefined' ? window.innerWidth - 32 : width), height }}>
      {/* Tab Header */}
      <div className="flex border-b border-[#E5E0D5]">
        <button
          onClick={() => setActiveTab("catholic")}
          className={`flex-1 py-2 px-3 text-xs font-['Nunito'] font-semibold transition-colors ${
            activeTab === "catholic" 
              ? "bg-[var(--liturgical-primary)] text-white" 
              : "text-[#6B665E] hover:bg-[#F0EBE0]"
          }`}
        >
          Catholic
        </button>
        <button
          onClick={() => setActiveTab("standard")}
          className={`flex-1 py-2 px-3 text-xs font-['Nunito'] font-semibold transition-colors ${
            activeTab === "standard" 
              ? "bg-[var(--liturgical-primary)] text-white" 
              : "text-[#6B665E] hover:bg-[#F0EBE0]"
          }`}
        >
          Standard
        </button>
      </div>
      
      {/* Content */}
      <div style={{ height: height - 40 }} className="overflow-hidden">
        {activeTab === "catholic" ? (
          <div className="p-3 overflow-y-auto overflow-x-hidden" style={{ height: "100%" }}>
            {/* Symbol Emojis */}
            <div className="mb-3">
              <p className="text-xs text-[#6B665E] font-['Nunito'] mb-2 font-semibold">Symbols</p>
              <div className="grid grid-cols-6 sm:grid-cols-7 gap-1">
                {CATHOLIC_SYMBOL_EMOJIS.map((emoji) => (
                  <button
                    key={emoji.symbol}
                    onClick={() => handleSymbolEmojiClick(emoji)}
                    className="w-9 h-9 sm:w-10 sm:h-10 rounded-lg hover:bg-[#F0EBE0] transition-colors flex items-center justify-center text-xl sm:text-2xl"
                    title={emoji.name}
                  >
                    {emoji.symbol}
                  </button>
                ))}
              </div>
            </div>
            
            {/* Image Emojis */}
            <div>
              <p className="text-xs text-[#6B665E] font-['Nunito'] mb-2 font-semibold">Images</p>
              <div className="grid grid-cols-4 gap-1 sm:gap-2">
                {CATHOLIC_IMAGE_EMOJIS.map((emoji) => (
                  <button
                    key={emoji.id}
                    onClick={() => handleCatholicEmojiClick(emoji)}
                    className="w-12 h-12 sm:w-14 sm:h-14 rounded-lg hover:bg-[#F0EBE0] transition-colors flex items-center justify-center p-1"
                    title={emoji.name}
                  >
                    <img 
                      src={emoji.url} 
                      alt={emoji.name} 
                      className="w-full h-full object-contain"
                    />
                  </button>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <EmojiPicker
            onEmojiClick={handleStandardEmojiClick}
            width="100%"
            height={height - 40}
            categories={ALLOWED_CATEGORIES}
            hiddenEmojis={HIDDEN_EMOJIS}
            searchDisabled={false}
            skinTonesDisabled
            previewConfig={{ showPreview: false }}
            lazyLoadEmojis={true}
          />
        )}
      </div>
    </div>
  );
}

// Helper to render Catholic emoji in text
export function renderTextWithCatholicEmojis(text) {
  if (!text) return text;
  
  const catholicEmojiMap = {};
  CATHOLIC_EMOJIS.forEach(e => {
    catholicEmojiMap[e.id] = e;
  });
  
  // Replace [catholic:id] with img tags
  return text.replace(/\[catholic:(\w+)\]/g, (match, id) => {
    const emoji = catholicEmojiMap[id];
    if (emoji) {
      return `<img src="${emoji.url}" alt="${emoji.name}" class="inline-block w-5 h-5 align-text-bottom" />`;
    }
    return match;
  });
}

// Export the emoji list for use elsewhere
export { CATHOLIC_EMOJIS };
